<!-- eslint-disable -->
<template>
  <CommonPages id="about" classs="about-page" titlePrefix="About Us - NONCEBEATS"
    metaDescription="Join NONCEBEATS to connect advertisers and publishers worldwide. Buy and sell premium ad inventory in real time, optimize campaigns, and maximize ROI with transparency and efficiency.">
    <div class="page-header"></div>
    <section class="about-story-section">
      <div class="about-story-section__content">
        <h1 class="about-story-section__title">Our story</h1>
        <p class="about-story-section__description">
          Founded by digital advertising experts, we simplify ad trading with advanced technology
          and dedicated support, helping clients worldwide efficiently buy and sell ad inventory.
        </p>
      </div>
      <div class="about-story-section__image-container">
        <img :src="storyImage1" alt="Our story" class="about-story-section__image">
      </div>
    </section>
    <section class="about-connect-section">
      <div class="about-connect-section__image-container">
        <img :src="storyImage2" alt="Connecting advertisers"
          class="about-connect-section__image">
      </div>
      <div class="about-connect-section__content">
        <h2 class="about-connect-section__title">Bridging Advertisers on a Transparent Platform</h2>
        <p class="about-connect-section__description">
          Over time, we’ve empowered hundreds of clients globally to efficiently buy and sell
          advertising inventory, delivering measurable results. Dedicated to innovation and quality,
          we constantly evolve to meet the fast-changing demands of the digital advertising
          landscape.
        </p>
      </div>
    </section>
  </CommonPages>
</template>

<script>
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue';
import '@/css/about.scss';

export default {
  name: 'About',
  components: {
    CommonPages,
  },
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
    }),
    storyImage1 () {
      return this.deviceType === 'mobile'
        ? require('@/assets/story-1-m.png')
        : require('@/assets/story-1.png');
    },
    storyImage2 () {
      return this.deviceType === 'mobile'
        ? require('@/assets/story-2-m.png')
        : require('@/assets/story-2.png');
    },
  },
};
</script>
